export default __webpack_public_path__ + "static/media/download.e3545feb.svg";